module.exports = __webpack_public_path__ + "static/media/haskellReed.91e9a706.png";